export default "/images/vendor/flag-icons/flags/1x1/pe.svg?b8e62fe370160622092e506955270d31";